module.exports = __webpack_public_path__ + "static/media/inventory.92cc6df5.png";